<!-- Header -->
<div class="header-pack" id="package">
    <div class="container">

        <h2 class="text-white">Annual Membership Plans</h2>
        <p>
            Discover a year-long journey to your best self with our exclusive Red Monk Wellness memberships. Each
            tier is thoughtfully curated to provide a comprehensive suite of our most effective revitalising,
            aesthetic,
            and restorative treatments.
        </p>
    </div>
</div>

<!-- Pricing Section -->
<section class="section">
    <div class="container">
        <div class="section-title">
            <h2>Compare Our Tiers</h2>
        </div>

        <!-- Loading State for Membership Plans -->
        <div *ngIf="isLoadingMembershipPlans" class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-2">Loading membership plans...</p>
        </div>

        <!-- Error State for Membership Plans -->
        <div *ngIf="errorMessageMembershipPlans && !isLoadingMembershipPlans" class="alert alert-warning text-center">
            {{ errorMessageMembershipPlans }} (Showing default plans)
        </div>

        <div class="pricing-table" *ngIf="!isLoadingMembershipPlans">
            <!-- Dynamic Membership Plan Cards -->
            <div *ngFor="let plan of getDisplayMembershipPlans()" class="plan-card"
                [class.gold]="plan.planName.toLowerCase().includes('gold')"
                [class.platinum]="plan.planName.toLowerCase().includes('platinum')">

                <div class="plan-header">
                    <div class="plan-name">{{ plan.planName }}</div>
                    <!-- Uncomment if you want to show price from API -->
                    <!-- <div class="plan-price" *ngIf="plan.amount > 0">
                        <span class="currency">₹</span>{{ plan.amount.toLocaleString('en-IN') }}
                    </div> -->
                </div>

                <ul class="feature-list">
                    <li>
                        <span class="feature-name">IV Drip Session</span>
                        <span class="feature-value">{{ plan.dripSession }}</span>
                    </li>
                    <li>
                        <span class="feature-name">Beauty Treatments</span>
                        <span class="feature-value">{{ plan.beautyTreatment }}</span>
                    </li>
                    <li>
                        <span class="feature-name">HIFU Anti-Ageing Sessions</span>
                        <span class="feature-value">{{ plan.antiAgeing }}</span>
                    </li>
                </ul>

                <a routerLink="/package-enquire" class="enquire-btn">Enquire Now</a>
            </div>
        </div>
    </div>
</section>

<section class="benefits2 d-none">
    <div class="container">
        <div class="treatments">
            <h3>Your Choice of Beauty Treatments</h3>

            <p class="text-center">
                As a Gold or Platinum member, you may select from the following advanced
                treatments. Our specialists will consult with you to create the perfect combination for your
                unique goals.
            </p>

            <!-- Loading State for Packages -->
            <div *ngIf="isLoadingPackages" class="text-center py-5">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                <p class="mt-2">Loading beauty treatments...</p>
            </div>

            <!-- Error State for Packages -->
            <div *ngIf="errorMessagePackages && !isLoadingPackages" class="alert alert-warning text-center">
                {{ errorMessagePackages }} (Showing default treatments)
            </div>

            <div class="treatments-grid" *ngIf="!isLoadingPackages">
                <!-- Dynamic Package/Treatment Items -->
                <div *ngFor="let treatment of getDisplayPackages()" class="treatment-item">
                    <h4>{{ treatment.PackageName }}</h4>
                    <p>{{ treatment.Description }}</p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- Benefits -->
<section class="section">
    <div class="container">
        <div class="benefits">
            <div class="benefit-card">
                <i class="fas fa-user-md"></i>
                <h4>Platinum Members</h4>
                <p>
                    Get 12 Consultations From Our Doctors/Experts For Any Medical Discussions. Ask And Upload Any
                    Medical Reports And Discuss Anything Medically. Get A Dedicated Group For All Medical Helps.
                </p>
            </div>
            <div class="benefit-card">
                <i class="fas fa-stethoscope"></i>
                <h4>Gold Members</h4>
                <p>Get 6 Consultations Yearly For Any Medical Help.</p>
            </div>
        </div>
    </div>

    <!-- <div class="container">
        <div class="terms">
            <h3>Terms & Conditions</h3>
            <ul>
                <li>Membership is valid for 12 months from the date of purchase.</li>
                <li>All included services must be redeemed within the 12-month membership period.</li>
                <li>Treatments are subject to specialist consultation and availability.</li>
                <li>Appointments must be booked in advance.</li>
                <li>This membership is non-transferable and non-refundable.</li>
                <li>Services included in the plan cannot be exchanged for cash or other services.</li>
            </ul>
        </div>
    </div> -->

    <div class="container" *ngIf="terms.length > 0">
        <div class="terms">
            <h3>Terms &amp; Conditions</h3>
            <ul>
                <li *ngFor="let t of terms">{{ t.TermText }}</li>
            </ul>
        </div>
    </div>

</section>